import React from "react";

import { Graph } from "~/Graph";
import { Time } from "~/Time";

import { Query as Query_ } from "./Query";

export type Summary = Time.DateTime &
  Summary.SummaryMinMaxRange & {
    readonly totalDVIRs: number;
    readonly noDefectDVIRs: number;
    readonly resolvedDefects: number;
    readonly unresolvedDefects: number;
    readonly driversSummary: readonly Summary.DriverDvirSummary[];
  };

export namespace Summary {
  export import Query = Query_;

  export type Summaries = readonly Summary[];

  export type DriverDvirSummary = SummaryMinMaxRange & {
    readonly driverID: number;
    readonly totalDVIRs: number;
    readonly noDefectDVIRs: number;
    readonly resolvedDefects: number;
    readonly unresolvedDefects: number;
  };

  export type SummaryMinMaxRange = {
    readonly minDate: Time.DateTime;
    readonly maxDate: Time.DateTime;
  };

  export const use = (...args: Parameters<typeof Query.use>) => {
    const query = Query.use(...args);

    const { data, loading, error } = query;

    const decodedDataOrError = React.useMemo(() => {
      return data ? Query.decode(data) : undefined;
    }, [data]);

    const decodedData = React.useMemo(() => {
      const dataOrErrors = decodedDataOrError ? decodedDataOrError : [];
      if (!("graphError" in dataOrErrors)) {
        return dataOrErrors;
      }
      return [];
    }, [decodedDataOrError, error]);

    const errors = Graph.Errors.onError(error, decodedDataOrError);

    return {
      data: decodedData,
      loading,
      ...errors,
    };
  };

  export type DriversWithDVIRsByDay = Time.DateTime & {
    readonly drivers: readonly DriverDvirSummary[];
  };
}
